import { Container } from '@material-ui/core';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';

import { theme } from './theme';
import { GlobalStyle } from './theme/global';

export const AppContainer = styled(Container)`
	font-size: 1rem;
`;

interface ThemedProviderProps {
	children: JSX.Element | JSX.Element[];
}

export const ThemedProvider = ({ children }: ThemedProviderProps) => (
	<ThemeProvider theme={theme}>
		<GlobalStyle />
		<AppContainer maxWidth="xl">{children}</AppContainer>
	</ThemeProvider>
);
